module.exports = __webpack_public_path__ + "img/bg_top.a05551da.png";